import {createContext} from 'react';

const SizeMastersContext = createContext({
  fetchSizeMasters: () => {}
});

export default SizeMastersContext;
